export default class User {
  constructor(data) {
    for (const prop in data) {
      this[prop] = data[prop];
    }
  }
}
